import { ACTIONS } from 'actions/dashboard'

export const initialState = {
    appState: {
        dashboardLoaded: false,
        dashboardLoading: false,
        getDashboardError: null,
        goalModalError: null,
        goalModalLoading: false,
    },
    database: {
        goals: [],
        sections: [],
    },
}

export default (state = initialState, action) => {
    const { database, appState } = state

    switch (action.type) {
        case ACTIONS.GET_DASHBOARD.START:
            return {
                ...state,
                appState: { ...appState, dashboardLoading: true },
            }
        case ACTIONS.GET_DASHBOARD.SUCCESS:
            return {
                ...state,
                appState: { ...appState, dashboardLoaded: true, dashboardLoading: false, getDashboardError: null },
                database: { ...database, goals: [...action.data.goals], sections: [...action.data.sections] },
            }
        case ACTIONS.GET_DASHBOARD.FAILURE:
            return {
                ...state,
                appState: { ...appState, dashboardLoaded: false, dashboardLoading: false, getDashboardError: action.error },
            }

        case ACTIONS.DELETE_GOAL.START:
            return {
                ...state,
                appState: { ...appState, goalModalLoading: true },
            }
        case ACTIONS.DELETE_GOAL.SUCCESS:
            return {
                ...state,
                appState: { ...appState, goalModalLoading: false, goalModalError: null },
            }
        case ACTIONS.DELETE_GOAL.FAILURE:
            return {
                ...state,
                appState: { ...appState, goalModalLoading: false, goalModalError: action.error },
            }

        default:
            return state
    }
}
